import { Breadcrumbs, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Download } from "lucide-react";
import AddIcon from "@mui/icons-material/Add";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import dayjs from "dayjs";
import {
  Admin_Parivartan_Get_All_Branches,
  Admin_Parivartan_Get_All_Pincode,
} from "../../../constants";
import PincodeTableComponent from "./components/PincodeTableComponent";
import AddCityModal from "./components/AddCityModal";
import AddPincodeModal from "./components/AddPincodeModal";
import FilterComponent from "./components/FilterComponent";

const PincodeMasterComponent = () => {
  const [pincodeList, setPincodeList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [addCityModalOpen, setAddCityModalOpen] = useState(false);
  const [addPincodeModalOpen, setAddPincodeModalOpen] = useState(false);

  const [filters, setFilters] = useState({
    searchText: "",
  });

  const getPincodeData = async (filter) => {
    try {
      setLoading(true);
      const params = new URLSearchParams();

      if (filter.searchText) params.append("searchText", filter.searchText);

      const response = await axios.get(`${Admin_Parivartan_Get_All_Pincode}?${params.toString()}`);
      const data = response.data.data || [];
      setPincodeList(data);
      return data;
    } catch (error) {
      console.error("Error fetching branches:", error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPincodeData(filters);
  }, []);

  const handleBack = () => {};

  const handleApplyFilter = () => {};

  return (
    <>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link
          underline="hover"
          key="1"
          color="inherit"
          to="/settings"
          onClick={handleBack}
        >
          Admin Panel
        </Link>
        <Typography key="2" color="text.primary">
          Pincode Master
        </Typography>
      </Breadcrumbs>

      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold">Pincode Master</h1>
          </div>
          <div>
            <Button
              onClick={() => setAddCityModalOpen(true)}
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              sx={{ mr: 1 }}
            >
              Add New City
            </Button>

            <Button
              onClick={() => setAddPincodeModalOpen(true)}
              variant="contained"
              color="success"
              startIcon={<AddIcon />}
              sx={{ mr: 1 }}
            >
              Add New Pincode
            </Button>

            <Button
              //   onClick={() => handleExport()}
              variant="contained"
              color="secondary"
              startIcon={<Download />}
              sx={{ mr: 1 }}
            >
              Download
            </Button>
          </div>
        </div>

        <FilterComponent
          filters={filters}
          setFilters={setFilters}
          onApplyFilters={getPincodeData}
        />

        <PincodeTableComponent
          pincodeList={pincodeList}
          loading={loading}
          setLoading={setLoading}
          onRefresh={()=> getPincodeData(filters)}
        />

        <AddCityModal
          open={addCityModalOpen}
          onClose={() => setAddCityModalOpen(false)}
          onRefresh={()=> getPincodeData(filters)}
        />

        <AddPincodeModal
          open={addPincodeModalOpen}
          onClose={() => setAddPincodeModalOpen(false)}
          onRefresh={()=> getPincodeData(filters)}
        />
      </div>
    </>
  );
};

export default PincodeMasterComponent;
